import { section } from "@/neon";

section("newsletter", {
  onLoad() {},
  onUnload() {},
});
